import CohortLevelBar from "./CohortLevelBar";

const CohortLevelBarSection = ({ categories, showCohortMetric = true }) => {
  const levels = categories.map(({ id, title, count, icon, className }) => ({
    id,
    label: title,
    count,
    icon,
    className,
  }));

  return <CohortLevelBar levels={levels} showCohortMetric={showCohortMetric} />;
};

export default CohortLevelBarSection;
